import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentArrowUpFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 1c6 0 8 2 8 8v14H3V1zM6.863 11.36l1.274 1.273L11.1 9.669V17.5h1.8V9.67l2.963 2.963 1.274-1.273L12 6.224z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentArrowUpFilledSize24Glyph.displayName = 'DocumentArrowUpFilledSize24Glyph';
